import { type CompareDataDTOUpToV1, type CompareDataDTOV1, version } from './compare-data-v1';

export function upgrade(raw: CompareDataDTOUpToV1): CompareDataDTOV1 {
  return {
    ...raw,
    version,
  };
}
